import { render } from "./LeagueFormComponent.vue?vue&type=template&id=abb2db3c"
import script from "./LeagueFormComponent.vue?vue&type=script&lang=js"
export * from "./LeagueFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__